@if (showImage()) {
  <img
    [src]="flagUrl()"
    [width]="size()"
    [height]="height()"
    [alt]="altText()"
    [attr.aria-label]="altText()"
    decoding="async"
    draggable="false"
    (error)="onError()"
  />
} @else if (fallbackText()) {
  <span [attr.aria-label]="fallbackText()">{{ fallbackText() }}</span>
}
